import { types, Instance } from "mobx-state-tree";
// models
// helpers
import { formatPrice } from "src/base/helpers/price";

const PriceConditions = types
  .model({
    quantity: types.maybeNull(types.optional(types.string, "")),
  })
  .actions((self) => ({
    set(key, value) {
      self[key] = value;
    },
  }));

const ProductSimpleModel = types.model({
  id: types.maybeNull(types.number),
  title: types.maybeNull(types.optional(types.string, "")),
  slug: types.maybeNull(types.optional(types.string, "")),
  featured_image: types.maybeNull(types.optional(types.string, "")),
  price: types.maybeNull(types.optional(types.number, 0)),
  promotion_price: types.maybeNull(types.optional(types.number, 0)),
  sale_price: types.maybeNull(types.optional(types.number, 0)),
  collaborators_price: types.maybeNull(types.optional(types.number, 0)),
  wholesale_price: types.maybeNull(types.optional(types.number, 0)),
  collaborators_price_conditions: types.maybeNull(PriceConditions),
  wholesale_price_conditions: types.maybeNull(PriceConditions),
});

const ProductVariantModel = types.model({
  id: types.maybeNull(types.number),
  product_id: types.maybeNull(types.number),
  title: types.maybeNull(types.optional(types.string, "")),
  featured_image: types.maybeNull(types.optional(types.string, "")),
  price: types.maybeNull(types.optional(types.number, 0)),
  promotion_price: types.maybeNull(types.optional(types.number, 0)),
  sale_price: types.maybeNull(types.optional(types.number, 0)),
});

const CartModel = types
  .model({
    id: types.maybeNull(types.number),
    code: types.maybeNull(types.string),
    quantity: types.maybeNull(types.number),
    product_id: types.maybeNull(types.number),
    product_variant_id: types.maybeNull(types.number),
    product_simple: types.maybeNull(ProductSimpleModel),
    product_variant: types.maybeNull(ProductVariantModel),
  })
  .views((self) => {
    return {
      get title() {
        let title = self.product_simple.title;

        if (self.product_variant_id) {
          title += " - " + self.product_variant.title;
        }

        return title;
      },
      get variantTitle() {
        let title = "";

        if (self.product_variant_id) {
          title = self.product_variant.title;
        }

        return title;
      },
      get featuredImage() {
        let image = self.product_simple.featured_image;

        if (self.product_variant_id) {
          image = self.product_variant.featured_image;
        }

        return image;
      },
      get salePrice() {
        if (self.product_variant_id) {
          return self.product_variant.sale_price;
        }

        return self.product_simple.sale_price;
      },
      get salePriceFmt() {
        return formatPrice(this.salePrice.toString());
      },
      get orderPrice() {
        let result = this.salePrice;

        if (self.product_simple.wholesale_price_conditions) {
          let quantityCondition =
            parseInt(
              self.product_simple.wholesale_price_conditions?.quantity
            ) ?? 0;

          if (self.quantity >= quantityCondition) {
            return self.product_simple.wholesale_price;
          }
        }

        if (self.product_simple.collaborators_price_conditions) {
          let quantityCondition =
            parseInt(
              self.product_simple.collaborators_price_conditions?.quantity
            ) ?? 0;

          if (self.quantity >= quantityCondition) {
            return self.product_simple.collaborators_price;
          }
        }

        if (self.product_variant_id) {
          return self.product_variant.sale_price;
        }

        return result;
      },
      get orderPriceFmt() {
        return formatPrice(this.orderPrice.toString());
      },
      get subTotal() {
        return parseInt(this.orderPrice.toString()) * self.quantity;
      },
      get subTotalFmt() {
        return formatPrice(this.subTotal.toString());
      },
    };
  })
  .actions((self) => ({
    set(key, value) {
      self[key] = value;
    },
  }));

export interface ICartModel extends Instance<typeof CartModel> {}

export default CartModel;
